import styled from 'styled-components'
import { Tooltip } from 'sutra/components/Tooltip/Tooltip'

export const ScopeTooltip = styled(Tooltip)`
  max-width: 340px;
  max-height: 360px;
  overflow-y: auto;
`

export const ScopeTooltipContent = styled.div`
  font-size: 12px;
  line-height: 1.8;

  ul {
    margin: 0 0 6px;
    padding: 0 0 0 16px;
    list-style: disc;
  }
`

export const ScopeTooltipLabel = styled.div`
  font-weight: 600;
  margin-top: 4px;
  opacity: 0.85;
`
